import { Dashboard } from "@mui/icons-material";

export function DashboardIcon({
  className,
}: {
  readonly className?: string | undefined;
}): JSX.Element {
  return <Dashboard className={className ?? ""} />;
}
